import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ date }) {
  const start = new Date(`${date}T10:00:00+01:00`).getTime();
  const end = new Date(`${date}T18:00:00+01:00`).getTime();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (now >= end) return null;
  if (now >= start) {
    return (
      <p className="inline-flex items-center gap-2 font-cond uppercase font-bold text-lg text-[var(--leaf)]" data-testid="countdown-live">
        <span className="h-2.5 w-2.5 rounded-full bg-red-600 live-dot" aria-hidden />A Feira está a decorrer
      </p>
    );
  }
  const s = Math.floor((start - now) / 1000);
  const parts = [["dias", Math.floor(s / 86400)], ["horas", Math.floor((s % 86400) / 3600)], ["min", Math.floor((s % 3600) / 60)], ["seg", s % 60]];
  return (
    <div data-testid="countdown" aria-live="off">
      <p className="eyebrow text-slate-500 mb-2">Faltam</p>
      <ol className="flex gap-2 sm:gap-3">
        {parts.map(([label, v]) => (
          <li key={label} className="w-16 sm:w-20 py-2 bg-[var(--ink)] text-white text-center" data-testid={`countdown-${label}`}>
            <span className="block font-cond font-bold text-3xl sm:text-4xl leading-none tabular-nums">{pad(v)}</span>
            <span className="block text-[11px] uppercase tracking-wider mt-1 text-white/70">{label}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
